import React from 'react';
import SignInForm from "../../components/forms/app/auth/SignInForm";

let SignIn = () => <div className='login-page'>
    <SignInForm/>
</div>

export default SignIn;